import { mapGetters } from 'vuex'

export const spinButtonControlMixin = {
  data() {
    return {
      currentIndex: 0,
      isPlay: true,
      step: 1,
      infoStatus: false,
      infoText: ''
    }
  },
  computed: {
    ...mapGetters({
      spinSelectedButtons: 'spinControl/spinSelectedButtons'
    })
  },
  methods: {
    enableSpinButton(list, key) {
      return list.includes(key)
    },
    left() {
      this.canPlay()
      window.Sirv.getInstance('#smv').child(this.currentIndex).spin.rotateX(-this.step)
    },
    canPlay() {
      if (this.isPlay === false) return
      window.Sirv.getInstance('#smv').child(this.currentIndex).spin.pause()
      this.isPlay = false
    },
    playOrPause() {
      if (this.isPlay) {
        window.Sirv.getInstance('#smv').child(this.currentIndex).spin.pause()
        this.isPlay = false
      } else {
        window.Sirv.getInstance('#smv').child(this.currentIndex).spin.play()
        this.isPlay = true
      }
    },
    right() {
      this.canPlay()
      window.Sirv.getInstance('#smv').child(this.currentIndex).spin.rotateX(this.step)
    },
    up() {
      this.canPlay()
      window.Sirv.getInstance('#smv').child(this.currentIndex).spin.rotateY(-this.step)
    },
    down() {
      this.canPlay()
      window.Sirv.getInstance('#smv').child(this.currentIndex).spin.rotateY(this.step)
    },
    zoomIn() {
      this.canPlay()
      window.Sirv.getInstance('#smv').child(this.currentIndex).spin.zoomIn()
    },
    zoomOut() {
      this.canPlay()
      window.Sirv.getInstance('#smv').child(this.currentIndex).spin.zoomOut()
    },
    fullScreen() {
      this.canPlay()
      window.Sirv.getInstance('#smv').fullscreen();
    },
    info() {
      const frame = window.Sirv.getInstance('#smv').child(this.currentIndex).spin.currentFrame()
      const content = `Row: ${frame.row}, Col: ${frame.column}`
      this.infoText = content
      this.infoStatus = true

      setTimeout(() => {
        this.infoText = ''
        this.infoStatus = false
      }, 1500)
    }
  }
}
